export default {
	NONE: 'none', // 비공개
	ALWAYS: 'always', // 상시게시
	PERIOD: 'period', // 기간설정
};
